<div
  id="uzd-doplerometry"
  [ngStyle]="{'font-size.px': options.fontSize}"
  class="blank-layout">

  <h4 class="title">
    {{ options.title }}
  </h4>

  <form [formGroup]="form">
    <div class="clr-row">
      <div class="clr-col-sm-12">
        <input [ngStyle]="{ 'font-size.px': options.fontSize }" clrInput formControlName="dp_date" />
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">П.І.Б:</label>
          <input autocomplete="off" [ngStyle]="{ 'font-size.px': options.fontSize }" placeholder="" clrInput name="name" formControlName="dp_pib" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row button-row">
      <div class="clr-col-sm-12 button-left">
        <button class="btn btn-primary" (click)="copyDataToTextArea(' поздовжнє ', 'dp_polozennya')">  поздовжнє  </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea(' поперечне ', 'dp_polozennya')">  поперечне  </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea(' косе ', 'dp_polozennya')"> косе </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea(' нестійке ', 'dp_polozennya')">  нестійке  </button>
      </div>
      <div class="clr-col-sm-12 full-width-input">
        <clr-textarea-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Положення плода:</label>
          <textarea [ngStyle]="{ 'font-size.px': options.fontSize }" clrTextarea name="description" formControlName="dp_polozennya"></textarea>
        </clr-textarea-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Опис рубця:</label>
          <input autocomplete="off" [ngStyle]="{ 'font-size.px': options.fontSize }" placeholder="" clrInput name="name" formControlName="dp_rubets" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-select-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Передлежання:</label>
          <select [ngStyle]="{ 'font-size.px': options.fontSize }" clrSelect name="options" formControlName="dp_peredlezannya">
            <option value="головне">головне</option>
            <option value="сідничне">сідничне</option>
          </select>
        </clr-select-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-select-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Серцебиття:</label>
          <select [ngStyle]="{ 'font-size.px': options.fontSize }" clrSelect name="options" formControlName="dp_sertse">
            <option value="ритмічне">ритмічне</option>
            <option value="аритмічне">аритмічне</option>
          </select>
        </clr-select-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">ЧСС:</label>
          <input autocomplete="off" [ngStyle]="{ 'font-size.px': options.fontSize }" placeholder="" clrInput name="name" formControlName="dp_tss" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-select-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Рухи плода:</label>
          <select [ngStyle]="{ 'font-size.px': options.fontSize }" clrSelect name="options" formControlName="dp_moves">
            <option value="активні">активні</option>
            <option value="слабкі">слабкі</option>
          </select>
        </clr-select-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12">
        <div class="text-center-container text-left bold-text">
          <strong>Доплерометрія артерії пуповини</strong>
        </div>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">s/d:</label>
          <input autocomplete="off" [ngStyle]="{ 'font-size.px': options.fontSize }" placeholder="" clrInput name="name" formControlName="dp_art_sd" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">IR:</label>
          <input autocomplete="off" [ngStyle]="{ 'font-size.px': options.fontSize }" placeholder="" clrInput name="name" formControlName="dp_art_ir" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Pi:</label>
          <input autocomplete="off" [ngStyle]="{ 'font-size.px': options.fontSize }" placeholder="" clrInput name="name" formControlName="dp_art_pi" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-select-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Кровоплин:</label>
          <select [ngStyle]="{ 'font-size.px': options.fontSize }" clrSelect name="options" formControlName="dp_art_krovo">
            <option value="нормальний">нормальний</option>
            <option value="сповільнений">сповільнений</option>
          </select>
        </clr-select-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12">
        <div class="text-center-container text-left bold-text">
          <strong>Доплерометрія середньої мозкової артерії</strong>
        </div>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">s/d:</label>
          <input autocomplete="off" [ngStyle]="{ 'font-size.px': options.fontSize }" placeholder="" clrInput name="name" formControlName="dp_mat_sd" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">IR:</label>
          <input autocomplete="off" [ngStyle]="{ 'font-size.px': options.fontSize }" placeholder="" clrInput name="name" formControlName="dp_mat_ir" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Pi:</label>
          <input autocomplete="off" [ngStyle]="{ 'font-size.px': options.fontSize }" placeholder="" clrInput name="name" formControlName="dp_mat_pi" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-select-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Кровоплин:</label>
          <select [ngStyle]="{ 'font-size.px': options.fontSize }" clrSelect name="options" formControlName="dp_mat_krovo">
            <option value="нормальний">нормальний</option>
            <option value="сповільнений">сповільнений</option>
          </select>
        </clr-select-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12">
        <div class="text-center-container text-left bold-text">
          <strong>Доплерометрія маткових атретій</strong>
        </div>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12">
        <div class="text-left bold-text">
          <strong>Ліва</strong>
        </div>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">IR:</label>
          <input autocomplete="off" [ngStyle]="{ 'font-size.px': options.fontSize }" placeholder="" clrInput name="name" formControlName="dp_liva_ir" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Pi:</label>
          <input autocomplete="off" [ngStyle]="{ 'font-size.px': options.fontSize }" placeholder="" clrInput name="name" formControlName="dp_liva_pi" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-select-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Кровоплин:</label>
          <select [ngStyle]="{ 'font-size.px': options.fontSize }" clrSelect name="options" formControlName="dp_liva_krovo">
            <option value="нормальний">нормальний</option>
            <option value="сповільнений">сповільнений</option>
          </select>
        </clr-select-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12">
        <div class="text-small-padding text-left bold-text">
          <strong>Права</strong>
        </div>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">IR:</label>
          <input autocomplete="off" [ngStyle]="{ 'font-size.px': options.fontSize }" placeholder="" clrInput name="name" formControlName="dp_prava_ir" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Pi:</label>
          <input autocomplete="off" [ngStyle]="{ 'font-size.px': options.fontSize }" placeholder="" clrInput name="name" formControlName="dp_prava_pi" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-select-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Кровоплин:</label>
          <select [ngStyle]="{ 'font-size.px': options.fontSize }" clrSelect name="options" formControlName="dp_prava_krovo">
            <option value="нормальний">нормальний</option>
            <option value="сповільнений">сповільнений</option>
          </select>
        </clr-select-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <app-doctors [parentForm]="form" [fontSize]="options.fontSize"></app-doctors>
      </div>
    </div>

    <div class="clr-row">
      <div class="print-block"></div>
    </div>

  </form>
</div>

<app-blank-actions
  [font]="options.fontSize"
  (print)="printCurrentPage()"
  (fontSize)="updateFontSize($event)">
</app-blank-actions>
